/* MANJI Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Sticky navbar shadow on scroll ── */
  const header = document.querySelector('.manji-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    });
  }

  /* ── YMM cascading dropdowns (basic JS version) ──
     For full dynamic make/model/submodel data,
     populate window.ManjYMMData from a theme block or metafield.
     Format: { bmw: { models: ['M3','M4','330i'], submodels: { M3: ['Competition','Standard'] } } }
  */
  const makeSelect = document.getElementById('ymm-make');
  const modelSelect = document.getElementById('ymm-model');
  const submodelSelect = document.getElementById('ymm-submodel');

  if (makeSelect && modelSelect && window.ManjYMMData) {
    makeSelect.addEventListener('change', function () {
      const make = this.value;
      modelSelect.innerHTML = '<option value="">Model</option>';
      submodelSelect.innerHTML = '<option value="">Submodel</option>';
      if (make && window.ManjYMMData[make]) {
        window.ManjYMMData[make].models.forEach(function (m) {
          modelSelect.innerHTML += '<option value="' + m.toLowerCase() + '">' + m + '</option>';
        });
      }
    });

    modelSelect.addEventListener('change', function () {
      const make = makeSelect.value;
      const model = this.value;
      submodelSelect.innerHTML = '<option value="">Submodel</option>';
      if (make && model && window.ManjYMMData[make] && window.ManjYMMData[make].submodels && window.ManjYMMData[make].submodels[model]) {
        window.ManjYMMData[make].submodels[model].forEach(function (s) {
          submodelSelect.innerHTML += '<option value="' + s.toLowerCase() + '">' + s + '</option>';
        });
      }
    });
  }

  /* ── Cart drawer open/close (stub — extend as needed) ── */
  const cartTrigger = document.querySelector('[data-cart-trigger]');
  if (cartTrigger) {
    cartTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('manji:cart:open'));
    });
  }

  const menuOpenBtn = document.querySelector('[data-manji-menu-open]');
  const overlay = document.querySelector('[data-manji-menu-overlay]');
  const drawer = document.getElementById('ManjiMobileDrawer');
  const menuCloseBtn = document.querySelector('[data-manji-menu-close]');

  function setMenuOpen(open) {
    if (!overlay || !drawer || !menuOpenBtn) return;
    menuOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.hidden = !open;
    drawer.hidden = !open;
    overlay.classList.toggle('is-open', open);
    drawer.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  if (menuOpenBtn && overlay && drawer) {
    menuOpenBtn.addEventListener('click', function () { setMenuOpen(true); });
    overlay.addEventListener('click', function () { setMenuOpen(false); });
    if (menuCloseBtn) menuCloseBtn.addEventListener('click', function () { setMenuOpen(false); });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenuOpen(false);
    });
  }

  function handleize(input) {
    return String(input || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeYearsMap(data) {
    if (!data) return null;
    if (data.years && typeof data.years === 'object') return data.years;
    return data;
  }

  function getNodeLabel(node, fallbackKey) {
    if (!node) return String(fallbackKey || '');
    if (typeof node === 'string') return node;
    if (typeof node === 'object' && typeof node.label === 'string') return node.label;
    return String(fallbackKey || '');
  }

  function getMakesNode(yearNode) {
    if (!yearNode) return null;
    if (typeof yearNode === 'object' && yearNode.makes && typeof yearNode.makes === 'object') return yearNode.makes;
    if (typeof yearNode === 'object') return yearNode;
    return null;
  }

  function getModelsNode(makeNode) {
    if (!makeNode) return null;
    if (typeof makeNode === 'object' && makeNode.models && typeof makeNode.models === 'object') return makeNode.models;
    if (typeof makeNode === 'object') return makeNode;
    return null;
  }

  function getSubmodelsNode(modelNode) {
    if (!modelNode) return null;
    if (Array.isArray(modelNode)) return modelNode;
    if (typeof modelNode === 'object' && Array.isArray(modelNode.submodels)) return modelNode.submodels;
    if (typeof modelNode === 'object' && typeof modelNode.submodels === 'object') return modelNode.submodels;
    if (typeof modelNode === 'object') return modelNode;
    return null;
  }

  function clearSelect(selectEl, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = '';
    const opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder || 'Select';
    selectEl.appendChild(opt);
    selectEl.value = '';
  }

  function setFieldVisible(form, fieldName, visible) {
    const wrap = form.querySelector('.manji-ymm-field[data-field="' + fieldName + '"]');
    if (!wrap) return;
    wrap.hidden = !visible;
  }

  function setSubmitEnabled(form, enabled) {
    const btn = form.querySelector('[data-ymm-submit]');
    if (btn) btn.disabled = !enabled;
  }

  document.querySelectorAll('[data-manji-ymm-form]').forEach(function (form) {
    const yearEl = form.querySelector('[data-ymm-year]');
    const makeEl = form.querySelector('[data-ymm-make]');
    const modelEl = form.querySelector('[data-ymm-model]');
    const submodelEl = form.querySelector('[data-ymm-submodel]');

    if (!yearEl || !makeEl || !modelEl || !submodelEl) return;

    const yearsMap = normalizeYearsMap(window.ManjYMMData);
    const requireSubmodel = String(form.dataset.requireSubmodel || '').toLowerCase() === 'true';

    function populateYearsIfDataPresent() {
      if (!yearsMap || typeof yearsMap !== 'object') return;
      const years = Object.keys(yearsMap).filter(Boolean).sort(function (a, b) { return Number(b) - Number(a); });
      if (!years.length) return;

      const placeholder = yearEl.querySelector('option') ? yearEl.querySelector('option').textContent : 'Year';
      clearSelect(yearEl, placeholder);
      years.forEach(function (y) {
        const opt = document.createElement('option');
        opt.value = y;
        opt.textContent = y;
        yearEl.appendChild(opt);
      });
    }

    function resetAfterYear() {
      clearSelect(makeEl, makeEl.querySelector('option') ? makeEl.querySelector('option').textContent : 'Make');
      clearSelect(modelEl, modelEl.querySelector('option') ? modelEl.querySelector('option').textContent : 'Model');
      clearSelect(submodelEl, submodelEl.querySelector('option') ? submodelEl.querySelector('option').textContent : 'Submodel');
      makeEl.disabled = true;
      modelEl.disabled = true;
      submodelEl.disabled = true;
      setFieldVisible(form, 'make', false);
      setFieldVisible(form, 'model', false);
      setFieldVisible(form, 'submodel', false);
      setSubmitEnabled(form, false);
    }

    function resetAfterMake() {
      clearSelect(modelEl, modelEl.querySelector('option') ? modelEl.querySelector('option').textContent : 'Model');
      clearSelect(submodelEl, submodelEl.querySelector('option') ? submodelEl.querySelector('option').textContent : 'Submodel');
      modelEl.disabled = true;
      submodelEl.disabled = true;
      setFieldVisible(form, 'model', false);
      setFieldVisible(form, 'submodel', false);
      setSubmitEnabled(form, false);
    }

    function resetAfterModel() {
      clearSelect(submodelEl, submodelEl.querySelector('option') ? submodelEl.querySelector('option').textContent : 'Submodel');
      submodelEl.disabled = true;
      setFieldVisible(form, 'submodel', false);
      setSubmitEnabled(form, !requireSubmodel);
    }

    function populateMakes(year) {
      if (!yearsMap || !year || !yearsMap[year]) return null;
      const yearNode = yearsMap[year];
      const makesNode = getMakesNode(yearNode);
      if (!makesNode || typeof makesNode !== 'object') return null;

      const placeholder = makeEl.querySelector('option') ? makeEl.querySelector('option').textContent : 'Make';
      clearSelect(makeEl, placeholder);

      Object.keys(makesNode).filter(Boolean).sort().forEach(function (makeKey) {
        const opt = document.createElement('option');
        opt.value = makeKey;
        opt.textContent = getNodeLabel(makesNode[makeKey], makeKey);
        makeEl.appendChild(opt);
      });

      makeEl.disabled = false;
      setFieldVisible(form, 'make', true);
      return makesNode;
    }

    function populateModels(year, make) {
      if (!yearsMap || !year || !make || !yearsMap[year]) return null;
      const makesNode = getMakesNode(yearsMap[year]);
      if (!makesNode || !makesNode[make]) return null;
      const makeNode = makesNode[make];
      const modelsNode = getModelsNode(makeNode);
      if (!modelsNode || typeof modelsNode !== 'object') return null;

      const placeholder = modelEl.querySelector('option') ? modelEl.querySelector('option').textContent : 'Model';
      clearSelect(modelEl, placeholder);

      Object.keys(modelsNode).filter(Boolean).sort().forEach(function (modelKey) {
        const opt = document.createElement('option');
        opt.value = modelKey;
        opt.textContent = getNodeLabel(modelsNode[modelKey], modelKey);
        modelEl.appendChild(opt);
      });

      modelEl.disabled = false;
      setFieldVisible(form, 'model', true);
      return modelsNode;
    }

    function populateSubmodels(year, make, model) {
      if (!yearsMap || !year || !make || !model || !yearsMap[year]) return null;
      const makesNode = getMakesNode(yearsMap[year]);
      const makeNode = makesNode && makesNode[make];
      const modelsNode = getModelsNode(makeNode);
      const modelNode = modelsNode && modelsNode[model];
      const subNode = getSubmodelsNode(modelNode);
      if (!subNode) return null;

      const placeholder = submodelEl.querySelector('option') ? submodelEl.querySelector('option').textContent : 'Submodel';
      clearSelect(submodelEl, placeholder);

      if (Array.isArray(subNode)) {
        subNode.forEach(function (subKey) {
          if (!subKey) return;
          const opt = document.createElement('option');
          opt.value = String(subKey);
          opt.textContent = String(subKey);
          submodelEl.appendChild(opt);
        });
      } else if (typeof subNode === 'object') {
        Object.keys(subNode).filter(Boolean).sort().forEach(function (subKey) {
          const opt = document.createElement('option');
          opt.value = subKey;
          opt.textContent = getNodeLabel(subNode[subKey], subKey);
          submodelEl.appendChild(opt);
        });
      }

      const hasAny = submodelEl.querySelectorAll('option').length > 1;
      if (!hasAny) return null;

      submodelEl.disabled = false;
      setFieldVisible(form, 'submodel', true);
      setSubmitEnabled(form, !requireSubmodel);
      return subNode;
    }

    populateYearsIfDataPresent();
    resetAfterYear();
    setFieldVisible(form, 'year', true);

    yearEl.addEventListener('change', function () {
      resetAfterYear();
      const year = yearEl.value;
      if (!year) return;

      if (yearsMap) {
        populateMakes(year);
      } else {
        makeEl.disabled = false;
        setFieldVisible(form, 'make', true);
      }
    });

    makeEl.addEventListener('change', function () {
      resetAfterMake();
      const year = yearEl.value;
      const make = makeEl.value;
      if (!year || !make) return;

      if (yearsMap) {
        populateModels(year, make);
      } else {
        modelEl.disabled = false;
        setFieldVisible(form, 'model', true);
      }
    });

    modelEl.addEventListener('change', function () {
      resetAfterModel();
      const year = yearEl.value;
      const make = makeEl.value;
      const model = modelEl.value;
      if (!year || !make || !model) return;

      if (yearsMap) {
        populateSubmodels(year, make, model);
      } else {
        submodelEl.disabled = false;
        setFieldVisible(form, 'submodel', true);
        setSubmitEnabled(form, !requireSubmodel);
      }

      setSubmitEnabled(form, !requireSubmodel);
    });

    submodelEl.addEventListener('change', function () {
      if (!requireSubmodel) return;
      setSubmitEnabled(form, Boolean(submodelEl.value));
    });

    form.addEventListener('submit', function (e) {
      const year = yearEl.value;
      const make = makeEl.value;
      const model = modelEl.value;
      const submodel = submodelEl.value;

      if (!year || !make || !model) return;
      if (requireSubmodel && !submodel) return;

      e.preventDefault();

      const resultMode = (form.dataset.resultMode || '').trim() || 'vehicle_collection';
      if (resultMode === 'vehicle_collection') {
        const handleParts = [year, make, model];
        if (submodel) handleParts.push(submodel);
        const handle = handleize(handleParts.join(' '));
        if (!handle) return;
        window.location.href = '/collections/' + encodeURIComponent(handle);
        return;
      }

      const yPrefix = form.dataset.yearPrefix || '';
      const makePrefix = form.dataset.makePrefix || '';
      const modelPrefix = form.dataset.modelPrefix || '';
      const subPrefix = form.dataset.submodelPrefix || '';

      let collectionHandle = (form.dataset.collectionHandle || '').trim();
      const useMakeAsCollection = !collectionHandle;
      if (useMakeAsCollection) collectionHandle = handleize(make);
      if (!collectionHandle) collectionHandle = 'all';

      const tags = [];
      tags.push(handleize(yPrefix + year));
      if (!useMakeAsCollection) tags.push(handleize(makePrefix + make));
      tags.push(handleize(modelPrefix + model));
      if (submodel) tags.push(handleize(subPrefix + submodel));

      const tagPath = tags.filter(Boolean).join('+');
      const url = '/collections/' + encodeURIComponent(collectionHandle) + (tagPath ? '/' + tagPath : '');
      window.location.href = url;
    });
  });

});
